import { removeUndefinedFieldsFromObject } from '@vfde-brix/ws10/core';
import {
    Button,
    BUTTON_COLOR_PRIMARY,
    BUTTON_SIZE_STANDARD,
    BUTTON_WIDTH_VARIATION_FULLWIDTH,
    createButton,
    IButtonBusinessLogic,
    IButtonProperties,
} from '@vfde-brix/ws10/button';
import { IButtonOptionalParams } from 'Container/CancellationForm/interface';

/**
 * Create and mount button ws10 component
 */
export const mountButton = (containerElementId: string, optionalProps: IButtonOptionalParams): Button | null => {
    const { stdContent, icon, onClick } = optionalProps;
    const containerElement = document.getElementById(containerElementId);
    const business: IButtonBusinessLogic = onClick ? { onClick } : {};
    const props = <IButtonProperties>removeUndefinedFieldsFromObject({
        optColor: BUTTON_COLOR_PRIMARY,
        optWidthVariation: BUTTON_WIDTH_VARIATION_FULLWIDTH,
        optSize: BUTTON_SIZE_STANDARD,
        stdContent,
        icon,
        business,
    });

    return containerElement && createButton(containerElement, props);
};
